module.exports = function pearson(a, b) {
    var i = 0,
        ii = a.length,
        d = 0;
    for (; i < ii; i++) {
        d += ((a[i] - b[i]) * (a[i] - b[i])) / b[i];
    }
    return d;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/pearson.js
 ** module id = 92
 ** module chunks = 0
 **/